import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FILTRO_PADRAO, PARAMS_FILTRO, filtroDaUrl, paramsDoFiltro, type FiltroPaineis } from '@/utils/filtroPaineis';

export interface EstadoFiltroPaineis {
  filtro: FiltroPaineis;
  /** O que vai na chamada da API (vazio = padrão da aba). Mesma referência enquanto o filtro não muda. */
  params: Record<string, string>;
  definir: (novo: FiltroPaineis) => void;
  limpar: () => void;
}

/**
 * O filtro dos painéis, lido e escrito no endereço da página. Outros parâmetros da URL
 * (o `?mes=` dos apontamentos, por exemplo) ficam como estão.
 */
export function useFiltroPaineis(): EstadoFiltroPaineis {
  const [busca, setBusca] = useSearchParams();
  const filtro = useMemo(() => filtroDaUrl(busca), [busca]);
  const chave = JSON.stringify(paramsDoFiltro(filtro));
  const params = useMemo(() => JSON.parse(chave) as Record<string, string>, [chave]);

  const definir = useCallback(
    (novo: FiltroPaineis) => {
      setBusca((atual) => {
        const proxima = new URLSearchParams(atual);
        PARAMS_FILTRO.forEach((p) => proxima.delete(p));
        Object.entries(paramsDoFiltro(novo)).forEach(([k, v]) => proxima.set(k, v));
        return proxima;
      });
    },
    [setBusca],
  );

  const limpar = useCallback(() => definir(FILTRO_PADRAO), [definir]);

  return { filtro, params, definir, limpar };
}
